export const apiBaseUrl = process.env.REACT_APP_BASE_API_URL as string;
export const stripeKey = process.env.REACT_APP_STRIPE_KEY as string;
export const reCaptchaSiteKey = process.env
  .REACT_APP_RECAPTCHA_SITE_KEY as string;
export const titleSuffix = " | DocuMT";
